




























import GlobalMixin from "@/shared/mixins/globalMixin";
import { Component, Mixins, Prop, Watch } from "vue-property-decorator";

//Resumo
import Resumo from "./components/aquisicao/Resumo.vue";

//Graficos
import GraficoTotalAssinantes from "./components/aquisicao/GraficoTotalAssinantes.vue";
import GraficoCadastroDiario from "./components/aquisicao/GraficoCadastroDiario.vue";
import GraficoCadastroAcumulado from "./components/aquisicao/GraficoCadastroAcumulado.vue";
import GraficoCadastroDonut from "./components/aquisicao/GraficoCadastroDonut.vue";

import {
  Cadastros,
  DashboardService,
  TotalAssinantes,
} from "@/services/dashboard.service";

@Component({
  components: {
    Resumo,
    GraficoTotalAssinantes,
    GraficoCadastroDiario,
    GraficoCadastroAcumulado,
    GraficoCadastroDonut,
  },
})
export default class Aquisicao extends Mixins(GlobalMixin) {
  //Assinantes
  loadingAssinantes = false;
  totalAssinantes: TotalAssinantes[] | null = null;
  //Fim Assinantes

  //Cadastros
  loadingCadastros = false;
  cadastros: Cadastros[] | null = null;
  //Fim Cadastros

  data: string | null = null;

  mounted() {
    this.onChangeValue(this.value);
  }

  @Prop() readonly value!: string;
  @Watch("value")
  onChangeValue(val: string) {
    this.data = val;
    this.carregarAssinantes();
    this.carregarCadastros();
  }
  @Watch("data")
  onChangeData(val: string) {
    this.$emit("input", val);
  }

  //Uma requisição devolve a fonte para três gráficos
  //Faturamento por dia, acumulado e planos por dia
  async carregarAssinantes() {
    this.loadingAssinantes = true;
    if (this.data) {
      this.totalAssinantes = await DashboardService.Planos(this.data).finally(
        () => (this.loadingAssinantes = false)
      );
    }
  }

  async carregarCadastros() {
    this.loadingCadastros = true;
    if (this.data) {
      this.cadastros = await DashboardService.Cadastros(this.data).finally(
        () => (this.loadingCadastros = false)
      );
    }
  }
}
